import React from 'react';
import { cn } from '@/lib/utils';
import { CheckIcon } from 'lucide-react';

interface CreateInvoiceStepItemProps {
  stepNumber: number;
  title: string;
  isActive: boolean;
  className?: string;
  isCompleted: boolean;
}

const CreateInvoiceStepItem: React.FC<CreateInvoiceStepItemProps> = ({
  stepNumber,
  title,
  isActive,
  className,
  isCompleted
}) => {
  return (
    <div className={cn('z-[2] bg-white flex items-center gap-2', className)}>
      <span
        className={cn(
          'rounded-full border flex items-center justify-center w-[24px] h-[24px] text-secondary text-sm',
          isActive && 'border-primary bg-primary text-white',
          isCompleted && 'border-primary bg-primary text-white'
        )}
      >
        {isCompleted ? <CheckIcon className="w-[13px] h-[13px] text-white" strokeWidth={3.5} /> : stepNumber}
      </span>
      <p className={cn('text-sm text-secondary', (isActive || isCompleted) && 'text-[#1C1C1C]')}>{title}</p>
    </div>
  );
};

export default CreateInvoiceStepItem;
